import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const BundlePrice = ({ b, onSave }) => {
  const [price, setPrice] = useState(b.price || "");
  const [discount, setDiscount] = useState(b.discount ?? 25);
  useEffect(() => {
    setPrice(b.price || "");
    setDiscount(b.discount ?? 25);
  }, [b.price, b.discount]);

  return (
    <div className="border border-[#2A2325]/10 bg-[#FFFDF9] p-6" data-testid="bundle-price-card">
      <div className="eyebrow mb-3">Price on softspinepress.com</div>
      <div className="flex items-center gap-2">
        <span className="text-sm">A$</span>
        <Input value={price} onChange={(e) => setPrice(e.target.value.replace(/[^\d.]/g, ""))} placeholder="29.95" className="rounded-none w-32" data-testid="bundle-price-input" />
        <Button variant="outline" className="rounded-none" onClick={() => onSave({ price })} data-testid="bundle-price-save-btn">Save price</Button>
      </div>
      <div className="text-sm text-[#5C5255] mt-4 space-y-1">
        <div data-testid="bundle-separate-total">Bought separately: {b.separate_total ? `A$${b.separate_total}` : "—"}{b.unpriced ? ` (${b.unpriced} title${b.unpriced > 1 ? "s" : ""} without a price)` : ""}</div>
        {b.saving && <div className="text-[#2F5D50] font-medium" data-testid="bundle-saving">Buyers save A${b.saving} ({b.saving_pct}%)</div>}
      </div>
      {b.separate_total && (
        <div className="flex flex-wrap items-center gap-2 mt-4 text-sm" data-testid="bundle-suggest">
          <span>Suggest</span>
          <Input type="number" min={0} max={90} value={discount} onChange={(e) => setDiscount(e.target.value)} className="rounded-none w-20 h-8" data-testid="bundle-discount-input" />
          <span>% off →</span>
          <strong data-testid="bundle-suggested-price">A${b.suggested_price}</strong>
          <Button size="sm" variant="ghost" className="rounded-none underline" onClick={() => onSave({ discount: Number(discount) || 0 })} data-testid="bundle-discount-apply-btn">Recalculate</Button>
          <Button size="sm" className="rounded-none bg-[#5E2B38] hover:bg-[#4A2029]" onClick={() => onSave({ price: b.suggested_price })} data-testid="bundle-use-suggested-btn">Use A${b.suggested_price}</Button>
        </div>
      )}
    </div>
  );
};
